import { IClientSectionSettings } from 'legacy/lut/features/partner360/sectionSettings/models/iSectionSettingsState'

import { ActualsValueTypes } from '../../models/actualValueTypes'

import { getActualsValueTypeExportPDFDefault } from './getActualsValueTypeExportPDFDefault'
import { getExportPlanActualsValueTypeKey } from './getExportPlanActualsValueTypeKey'

export const getExportPlanActualsValueType = (
  sectionSettings: Partial<IClientSectionSettings>,
  programType: string,
  isRetailer: boolean,
  isDistributor: boolean,
  availableActualsTypes?: ActualsValueTypes[],
  pdfActualsTypeDefault?: ActualsValueTypes
): ActualsValueTypes => {
  const tag = getExportPlanActualsValueTypeKey(programType, isDistributor)
  const isSettingsFieldExists = sectionSettings != null && tag in sectionSettings

  const actualsValueTypeDefault = getActualsValueTypeExportPDFDefault(
    pdfActualsTypeDefault,
    isRetailer,
    isDistributor
  )

  const actualsValueTypeFromSetting =
    ((sectionSettings as Record<string, unknown>)[tag] as ActualsValueTypes) ??
    actualsValueTypeDefault

  const exportPlanActualsValueType = isSettingsFieldExists
    ? actualsValueTypeFromSetting
    : actualsValueTypeDefault

  if (availableActualsTypes?.length) {
    if (availableActualsTypes.includes(exportPlanActualsValueType)) {
      return exportPlanActualsValueType
    }
    if (availableActualsTypes.includes(actualsValueTypeDefault)) {
      return actualsValueTypeDefault
    }

    return availableActualsTypes[0] ?? exportPlanActualsValueType
  }

  return exportPlanActualsValueType
}
